<template>
  <h-page id="app" >
    <h-layout>
      <h-layout-header>
        <Header />
      </h-layout-header>
      <h-layout-content>
        <router-view />
      </h-layout-content>
    </h-layout>
  </h-page>
</template>

<script>
import navList from './nav.config.js'
import Header from '@/components/Header.vue'
export default {
  name: 'app',
  components: { Header },
  computed: {
    menu () {
      navList.forEach(nav => {
        nav.title = this.$t(nav.title)
      })
      return navList
    }
  }
}
</script>
<style lang="scss" scoped>
  .h-layout {
    .h-layout-header {
      height: 68px;
    }
  }
</style>
